import { LinearGradient } from '@tamagui/linear-gradient';
import React, { ReactNode } from 'react';
import { YStack } from 'tamagui';
import { tokens } from 'tamagui-config';

import { IconSection } from './IconSection';
import { TextSection } from './TextSection';
import { TripleGlowBackground } from '../../../components/common/TripleGlowBackground';

interface DashboardCardProps {
  // Icon properties
  iconSrc: string;
  iconBgColor: string;
  iconColor: string;

  // Brand logo properties
  brandLogoSrc?: string;

  // Middle section text properties
  middlePrimaryText?: string;
  middlePrimaryTextColor?: string;
  middleSecondaryText?: string;
  middlePrimaryIcon?: ReactNode;
  middlePillText?: string;

  // Bottom section text properties
  bottomPrimaryText?: string;
  bottomPrimaryTextColor?: string;
  bottomSecondaryText?: string;
  bottomPrimaryIcon?: ReactNode;
  bottomPillText?: string;

  // Gradient properties
  backgroundGradientColors: string[];
  glowGradientColors?: string[];

  onPress?: () => void;
}

export const DashboardCard: React.FC<DashboardCardProps> = ({
  iconSrc,
  iconBgColor,
  iconColor,
  brandLogoSrc,
  middlePrimaryText,
  middlePrimaryTextColor,
  middleSecondaryText,
  middlePrimaryIcon,
  middlePillText,
  bottomPrimaryText,
  bottomPrimaryTextColor,
  bottomSecondaryText,
  bottomPrimaryIcon,
  bottomPillText,
  backgroundGradientColors,
  glowGradientColors,
  onPress,
}) => (
  <YStack
    width={395}
    height={432}
    borderRadius="$5"
    borderWidth={2}
    borderColor={tokens.color.transparentBorder}
    padding="$6"
    overflow="hidden"
    position="relative"
    onPress={onPress}>
    {/* Background Gradient */}
    <LinearGradient
      colors={backgroundGradientColors}
      start={[0, 0]}
      end={[1, 1]}
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
    />

    {glowGradientColors && <TripleGlowBackground gradientColors={glowGradientColors} />}

    {/* Content */}
    <YStack flex={1} zIndex={1}>
      {/* Top section: Icon and Brand Logo */}
      <IconSection
        iconSrc={iconSrc}
        iconBgColor={iconBgColor}
        iconColor={iconColor}
        brandLogoSrc={brandLogoSrc}
      />

      {/* Middle section: Status and Subtitle */}
      <TextSection
        primaryText={middlePrimaryText}
        secondaryText={middleSecondaryText}
        justifyContent="center"
        primaryIcon={middlePrimaryIcon}
        pillText={middlePillText}
        primaryTextColor={middlePrimaryTextColor}
      />

      {/* Bottom section: Value and Label */}
      <TextSection
        primaryText={bottomPrimaryText}
        secondaryText={bottomSecondaryText}
        justifyContent="flex-end"
        primaryIcon={bottomPrimaryIcon}
        pillText={bottomPillText}
        primaryTextColor={bottomPrimaryTextColor}
      />
    </YStack>
  </YStack>
);
